import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GridRequestQuery, Group, GroupItemsResult } from '@api/index';
import { SelectionType, TableColumn } from '@swimlane/ngx-datatable';
import { map } from 'rxjs';
import { TranslationService } from '../../transloco/services/translation.service';
@Component({
    selector: 'app-group-list',
    templateUrl: './group-list.component.html',
    standalone: false,
})
export class GroupListComponent {
    private translationService = inject(TranslationService);

    @Input() public groups: GroupItemsResult;
    @Output() public selectionChange = new EventEmitter<Group>();
    @Output() public gridRequestEvent = new EventEmitter<GridRequestQuery>();

    public columns$ = this.translationService.afterLanguageChanged$.pipe(
        map(() => {
            const columns: TableColumn[] = [
                { prop: 'name', name: this.translationService.translate('defaults.name'), canAutoResize: true },
                { prop: 'description', name: this.translationService.translate('defaults.description'), canAutoResize: true },
            ];

            return columns;
        })
    );

    public SelectionType = SelectionType;

    public emitSelect([group]: Group[]) {
        this.selectionChange.emit(group);
    }

    public gridRequested(gridRequestQuery: GridRequestQuery) {
        this.gridRequestEvent.emit(gridRequestQuery);
    }
}
